import { useSelector } from "react-redux";
import { goToLogin } from "../lib/accounts";

/**
 * Public tool pages render for everyone; the "beyond" actions gate on sign-in.
 * `requireSignin(fn)` runs fn when authed, else redirects to the accounts login
 * and returns back to the current page afterwards.
 */
export const useAuthGate = () => {
  const isAuthenticated = useSelector((s) => s.auth.tk !== null);
  const requireSignin = (fn) => {
    if (isAuthenticated) return fn?.();
    goToLogin();
    return undefined;
  };
  return { isAuthenticated, requireSignin };
};
